<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
        <a
          href="http://www.100ec.cn/enterprise/#/list?field=%E8%B7%A8%E5%A2%83%E7%94%B5%E5%95%86&category=%E5%85%A8%E9%83%A8"
          target="_blank"
          >更多</a
        >
      </div>
      <Company />
    </div>

    <Email />

    <div class="right-box">
      <div class="right-title">
        <span>热门投诉</span>
        <a href="/Index/complain.html" target="_blank">我要投诉</a>
      </div>
      <ul class="platform">
        <li
          v-for="(i, index) of platform"
          :key="index"
          @click="getPlatform(index)"
        >
          {{ i }}
          <i class="fa fa-fire fa-lg"></i>
        </li>
      </ul>
    </div>

    <!-- <div class="right-box">
      <div class="right-title">
        <span>图书推荐</span>
      </div>

      <a href="/zt/kjds/" target="_blank">
        <img
          src="/Public/Upload/image/20191101/1572609218183480.png"
          style="width: 80%; margin: 0 auto 20px"
        />
      </a>
    </div> -->
    <!-- <div class="right-box">
      <div class="right-title">
        <span>合作伙伴</span>
      </div>

      <ul class="partner-list">
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/ymx.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/ebay.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/my.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/klht.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/qqh.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/zz.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/syo.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/dhw.jpg?v=1.0"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/dlw.jpg?v=1.0"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/zmt.jpg"
            />
          </a>
        </li>
      </ul>
    </div> -->
    <div style="width: 365px">
      <img style="width: 100%" src="/Public/home/images/zyt/kh/kj.jpg" />
    </div>
    <div style="width: 365px; margin-top: 20px">
      <a>
        <img
          style="width: 100%"
          src="/Public/home/images/zyttk/zytgg/kjdst.jpg"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      params: {
        field: "跨境电商",
        tabs: ["出口跨境电商", "进口跨境电商", "跨境电商服务商"],
      },
      year: "",
      time: "",
      platform: [],
    };
  },
  created() {
    this.$store.commit("getCompanyTabs", this.params);
  },
  mounted() {
    if (new Date().getMonth >= 2) {
      this.year = new Date().getFullYear();
    } else {
      this.year = new Date().getFullYear() - 1;
      this.time = "whole_year";
    }
    axios
      .get(
        "https://www.100ec.cn/315/api/index.php?_a=product&f=most_company_list&type=" +
          this.$store.state.type +
          "&limit=20&year=" +
          this.year +
          "&time=" +
          this.time
      )
      .then((res) => {
        for (var i of res.data.list.slice(0, 10)) {
          this.platform.push(i.company);
        }
      });
  },
  methods: {
    getPlatform(index) {
      window.open(
        "/Index/complain_search.html?company=" + this.platform[index]
      );
    },
  },
};
</script>
<style>
.partner-list li {
  padding: 10px;
  flex: 0 0 20%;
}
.partner-list img {
  width: 106px;
  border-radius: 2px;
  opacity: 1;
  transition: all 0.3s ease;
}
</style>